import {
  resource, ResourceOptions, ResourcesItem, ResourcesReduxState,
} from 'redux-and-the-rest';
import { GUEST_USER } from '../../models/roleModel';

import { UserModel } from '../../models/userModel';
import Env from '../../utils/env';
import generateClientId from './utils/generateClientId';

const url = `${Env.API_URL}/users/session`;

const {
  reducers: userReducer,
  createItem: createUser,
  fetchItem: fetchUser,
  clearItem: clearUser,
  actions: userActions,
  getItem: getUser,
  updateItem: updateUser,
  getOrFetchItem,
  createUserSession,
  destroyUserSession,
} = resource<UserModel>(
  {
    name: 'user',
    url,
  },
  {
    createItem: {
      url: `${Env.API_URL}/users/registration`,
    },
    fetchItem: true,
    destroyItem: true,
    updateItem: {
      url: `${Env.API_URL}/users`,
      method: 'PUT',
    },
    clearItem: {
      actionCreator: 'clearItem',
    },
    createUserSession: {
      url: `${Env.API_URL}/users/session`,
      actionCreator: 'createItem',
      actionName: 'CREATE_USER',
      reducer: 'createItem',
    },
    destroyUserSession: {
      method: 'DELETE',
      url: `${Env.API_URL}/users/session`,
      actionCreator: 'destroyItem',
      actionName: 'DESTROY_USER_SESSION',
      reducer: 'destroyItem',
    },
  },
);

const createGuestUser = (): void => {
  createUser({
    id: generateClientId(),
    type: 'user',
    relationshipNames: ['roles'],
    roles: [{ id: GUEST_USER, type: 'role' }],
  });
};

const getOrFetchUser = (
  users: ResourcesReduxState<UserModel>,
  options?: ResourceOptions<UserModel>,
): ResourcesItem<UserModel> => getOrFetchItem(users, { include: ['schools'], ...options });

export {
  userReducer,
  userActions,
  createGuestUser,
  createUser,
  getUser,
  updateUser,
  fetchUser,
  getOrFetchUser,
  destroyUserSession,
  clearUser,
  createUserSession,
};
